import { HeaderMarket } from '@/components/portfolio';
import { Market } from '@/components/market';

export default function MarketPage() {
    return (
        <div>
            <HeaderMarket />
            <Market />
        </div>
    );
}
